import {Dialog} from "~/components/Dialog";
import {useBooleanHistoryState} from "~/apps/core/utils";
import React, {useCallback, useEffect, useRef} from "react";
import {Button} from "@mui/material";
import useTabVisibility from "use-tab-visibility";


type Listener = (event: any) => void

class Emitter {
    private listeners: Listener[] = [];
    private events = [];

    emit(event: any) {
        if (this.listeners.length > 0) {
            this.callListeners(event);
        } else {
            this.events.push(event);
        }
    }

    private callListeners(event: any) {
        for (const listener of this.listeners) {
            listener(event);
        }
    }

    addEventListener(listener: Listener) {
        this.listeners.push(listener);
        if (this.events) {
            for (const event of this.events.splice(0)) {
                this.callListeners(event);
            }
        }
    }

    removeEventListener(listener: Listener) {
        const index = this.listeners.indexOf(listener);
        if (index != -1) {
            this.listeners.splice(index, 1);
        }
    }
}

const emitter = new Emitter();


class RequestUserConfirmEvent {
    constructor(public readonly resolve: (value: any) => void, public readonly reject: (e: Error) => void) {}
}

class ForceUpdateEvent {}


export async function requestUserConfirmApplicationUpdate() {
    return new Promise<boolean>((resolve, reject) => {
        emitter.emit(new RequestUserConfirmEvent(resolve, reject))
    });
}

export function applicationUpdated() {
    emitter.emit(new ForceUpdateEvent());
}


export const AppUpdate = () => {
    const [open, setOpen] = useBooleanHistoryState("app-update");
    const { visible } = useTabVisibility();
    const $visible = useRef<boolean>(visible);
    const requestUserConfirmEvent = useRef<RequestUserConfirmEvent>();

    const handleClose = () => {
        setOpen(false).then(() => {
            if (requestUserConfirmEvent.current) {
                requestUserConfirmEvent.current.resolve(false);
                requestUserConfirmEvent.current = null;
            }
        });
    }

    const handleAcceptClick = () => {
        setOpen(false).then(() => {
            requestUserConfirmEvent.current.resolve(true);
            requestUserConfirmEvent.current = null;
        });
    }

    const handleRejectClick = () => {
        setOpen(false).then(() => {
            requestUserConfirmEvent.current.resolve(false);
            requestUserConfirmEvent.current = null;
        });
    }

    const handleEvent = useCallback(event => {
        if (event instanceof RequestUserConfirmEvent) {
            try {
                if ($visible.current && window.location.pathname == "/") {
                    event.resolve(true);
                } else {
                    requestUserConfirmEvent.current = event;
                    setOpen(true).catch(console.error);
                }
            } catch (e) {
                event.reject(e);
            }
        } else if (event instanceof ForceUpdateEvent) {
            window.location.replace("/");
        }
    }, []);

    useEffect(() => {
        emitter.addEventListener(handleEvent);
        return () => {
            emitter.removeEventListener(handleEvent);
        }
    }, [handleEvent]);

    useEffect(() => {
        $visible.current = visible;
    }, [visible])


    return (
        <Dialog
            open={open}
            title="Доступна новая версия"
            onClose={handleClose}
            actions={(
                <>
                    <Button size="small" color="additionalSecondary" onClick={handleRejectClick}>
                        Позже
                    </Button>
                    <Button size="small" color="additionalPrimary" onClick={handleAcceptClick}>
                        Обновить
                    </Button>
                </>
            )}
        >
            Для корректной работы рекомендуем обновить приложение
        </Dialog>
    )
}